// Fire-and-forget analytics. sendBeacon survives page unloads (e.g. tapping a tel: link).
let sessionId;
try {
    sessionId = sessionStorage.getItem('hx:sid');
    if (!sessionId) {
        sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('hx:sid', sessionId);
    }
} catch {
    sessionId = 'nosession';
}

export function track(uuid, type, extra = {}) {
    if (!uuid || track.disabled) return;
    const body = JSON.stringify({ type, sessionId, link: extra.link || type, ...extra });
    const url = `/api/card/${uuid}/track-click`;
    try {
        const blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return;
    } catch {
        // fall through to fetch
    }
    fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
}

// Previews in the dashboard must not record analytics.
track.disabled = false;
